import { useState, useEffect } from "react";
import {
	Button,
	TextField,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Box,
	Paper,
	Typography,
	Grid,
	Divider,
	InputAdornment,
	IconButton,
	Tooltip,
	FormControlLabel,
	Checkbox,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import useStyles from "./styles";
import {
	DevicesOtherOutlined,
	EditNoteOutlined,
	StorageOutlined,
	VpnKeyOutlined,
	OpenInNew,
	Add,
	DeleteOutlined,
	VpnLockOutlined,
	Close,
} from "@mui/icons-material";

// O TagSelector agora é "Inteligente" (gerencia a API internamente)
import TagSelector from "./tagSelectorComponent";

const TYPE_ACCESS_OPTIONS = [
	{ label: "VM/Servidor", value: 0 },
	{ label: "Banco de Dados", value: 1 },
	{ label: "Acesso Web", value: 2 },
	{ label: "VPN", value: 3 },
];

const IP_REGEX =
	/((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;

// --- DEFINIÇÃO DOS ESTADOS ---

const COMMON_STATE = {
	id: "",
	titulo: "",
	tags: [],
	observacoes: "",
	clienteId: "",
};

const VM_STATE = {
	...COMMON_STATE,
	acessoTipo: 0,
	ip: "",
	sshPort: "22",
	sshUser: "",
	sshPass: "",
	rootPass: "",
};

const DB_STATE = {
	...COMMON_STATE,
	acessoTipo: 1,
	dbHost: "",
	dbPort: "",
	dbName: "",
	dbUser: "",
	dbPass: "",
};

const WEB_STATE = {
	...COMMON_STATE,
	acessoTipo: 2,
	web_accesses: [{ url: "", login: "", pass: "" }],
};

const VPN_STATE = {
	...COMMON_STATE,
	acessoTipo: 3,
	vpnName: "",
	vpnGateway: "",
	vpnUser: "",
	vpnPass: "",
	vpnNTDomain: "",
	useL2TPEphemeral: false,
	enableIPsec: false,
	vpnPSK: "",
};

const getInitialStateByType = (type) => {
	switch (type) {
		case 0:
			return VM_STATE;
		case 1:
			return DB_STATE;
		case 2:
			return WEB_STATE;
		case 3:
			return VPN_STATE;
		default:
			return VM_STATE;
	}
};

export default function ServerForm({
	onCancel,
	onSave,
	initialData,
	acesso,
	setUrl,
	setCurrentType,
	setOpenDrawer,
	windowWidth,
}) {
	const theme = useTheme();
	const styles = useStyles(theme);

	// --- ESTADO DO FORMULÁRIO ---
	const [formData, setFormData] = useState(() => {
		if (initialData) return initialData;
		return VM_STATE;
	});

	const [errors, setErrors] = useState({});

	// --- EFFECT: Carregar dados Iniciais (Edição) ---
	useEffect(() => {
		if (initialData) {
			let currentType = 0;
			let parsedTags = [];

			// Extrai as tags dependendo de qual tabela de relacionamento veio
			if (initialData.rlFormVMs) {
				currentType = 0;
				parsedTags = initialData.rlFormVMs.map((r) => r.tags);
			} else if (initialData.rlFormDBs) {
				currentType = 1;
				parsedTags = initialData.rlFormDBs.map((r) => r.tags);
			} else if (initialData.rlFormAcessWebTags) {
				currentType = 2;
				parsedTags = initialData.rlFormAcessWebTags.map((r) => r.tags);
			} else if (initialData.rlFormVpnTags) {
				currentType = 3;
				parsedTags = initialData.rlFormVpnTags.map((r) => r.tags);
			}

			setFormData({
				...getInitialStateByType(currentType),
				...initialData,
				acessoTipo: currentType,
				tags: parsedTags,
				web_accesses: initialData.web_accesses || [
					{ url: "", login: "", pass: "" },
				],
			});

			if (setCurrentType) setCurrentType(currentType);
		} else {
			setFormData(VM_STATE);
		}
		setErrors({});
	}, [initialData, setUrl, setCurrentType]);

	// --- HANDLERS ---

	const handleTypeChange = (e) => {
		const newType = Number(e.target.value);
		setFormData((prev) => ({
			...getInitialStateByType(newType),
			titulo: prev.titulo,
			clienteId: prev.clienteId,
			id: prev.id,
		}));
		if (setCurrentType) setCurrentType(newType);
	};

	const handleChange = (e) => {
		const { name, value, checked, type } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: type === "checkbox" ? checked : value,
		}));

		if (name === "accessUrl" && setUrl) {
			setUrl(value);
		}
		if (errors[name]) {
			setErrors((prev) => ({ ...prev, [name]: "" }));
		}
	};

	// --- HANDLER DE TAGS  ---
	// Apenas recebe a nova lista de tags selecionadas do componente filho
	const handleTagsSelectionChange = (newSelectedTags) => {
		setFormData((prev) => ({
			...prev,
			tags: newSelectedTags,
		}));
	};

	// --- WEB ACCESS  ---
	const handleAddWebAccess = () => {
		setFormData((prev) => ({
			...prev,
			web_accesses: [...prev.web_accesses, { url: "", login: "", pass: "" }],
		}));
	};
	const handleRemoveWebAccess = (index) => {
		setFormData((prev) => {
			const newAccesses = [...prev.web_accesses];
			newAccesses.splice(index, 1);
			return { ...prev, web_accesses: newAccesses };
		});
	};
	const handleWebAccessChange = (index, field, value) => {
		setFormData((prev) => {
			const newAccesses = [...prev.web_accesses];
			newAccesses[index] = { ...newAccesses[index], [field]: value };
			return { ...prev, web_accesses: newAccesses };
		});
	};

	const handleOpenLink = (url) => {
		if (!url) return;
		let finalUrl = url.startsWith("http") ? url : `https://${url}`;
		window.open(finalUrl, "_blank");
	};

	// --- VALIDAÇÃO E SALVAMENTO ---
	const validate = () => {
		const newErrors = {};
		let isValid = true;
		if (
			formData?.ip &&
			formData?.ip?.trim() !== "" &&
			!IP_REGEX?.test(formData?.ip)
		) {
			newErrors.ip = "Formato de IP inválido.";
			isValid = false;
		}
		const portNum = Number(formData?.sshPort);
		if (
			formData?.sshPort &&
			(isNaN(portNum) || portNum < 1 || portNum > 65535)
		) {
			newErrors.sshPort = "Porta inválida.";
			isValid = false;
		}
		setErrors(newErrors);
		return isValid;
	};

	const handleSave = () => {
		if (!validate()) return;

		const tagsIds = formData.tags.map((t) => String(t.id));

		const trimmedData = {};

		Object.keys(formData).forEach((key) => {
			const value = formData[key];
			if (typeof value === "string") {
				trimmedData[key] = value?.trim();
			} else {
				trimmedData[key] = value;
			}
		});

		if (
			trimmedData?.web_accesses &&
			Array?.isArray(trimmedData?.web_accesses)
		) {
			trimmedData.web_accesses = trimmedData?.web_accesses?.map((item) => ({
				...item,
				url: typeof item?.url === "string" ? item?.url?.trim() : "",
				login: typeof item?.login === "string" ? item?.login?.trim() : "",
				pass: typeof item?.pass === "string" ? item?.pass?.trim() : "",
			}));
		}

		const finalData = {
			...trimmedData,
			tipo: Number(trimmedData.acessoTipo),
			sshPort: trimmedData.sshPort ? Number(trimmedData.sshPort) : null,
			dbPort: trimmedData.dbPort ? Number(trimmedData.dbPort) : null,
			tags: tagsIds,
		};

		if (onSave) onSave(finalData);
	};

	const getTagTitle = (type) => {
		switch (type) {
			case 0:
				return "Classificação";
			case 1:
				return "Tipo de Banco";
			case 2:
				return "Tipo de Acesso";
			case 3:
				return "Tipo de VPN";
			default:
				return "Tags";
		}
	};

	return (
		<Grid item xs={12}>
			{/* --- HEADER --- */}
			<Box sx={styles.boxHeader}>
				<Box sx={styles.headStcker}>
					<Box sx={styles.boxButtons}>
						<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
							{windowWidth < 900 && (
								<IconButton
									onClick={() => {
										setOpenDrawer(false);
										onCancel();
									}}
								>
									<Close />
								</IconButton>
							)}
							<Typography variant="body2" fontWeight={700}>
								{!!initialData ? `${acesso?.titulo || formData?.titulo}` : ""}
							</Typography>{" "}
						</Box>

						<Box sx={{ display: "flex", gap: 2 }}>
							<Button
								onClick={onCancel}
								color="inherit"
								variant="outlined"
								size="small"
							>
								Cancelar
							</Button>
							<Button
								onClick={handleSave}
								variant="contained"
								color="primary"
								size="small"
							>
								Salvar
							</Button>
						</Box>
					</Box>
				</Box>
			</Box>

			<Paper variant="outlined" sx={{ p: 2, borderRadius: 1 }}>
				<Typography variant="mySubtitle" gutterBottom>
					{!!initialData ? "Editar Acesso" : "Novo Acesso"}
				</Typography>
				<Divider sx={{ mt: 1, mb: 2 }} />

				<Box
					component="form"
					sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 1 }}
				>
					{/* --- TÍTULO --- */}
					<TextField
						name="titulo"
						label="Título / Identificação"
						size="small"
						value={formData?.titulo}
						onChange={handleChange}
						fullWidth
						required
					/>

					<Box
						sx={{
							display: "flex",
							gap: 2,
							flexDirection: { xs: "column", sm: "row" },
						}}
					>
						{/* --- SELECT TIPO --- */}
						{!initialData && (
							<FormControl fullWidth size="small">
								<InputLabel id="select-acesso-label">Tipo de acesso</InputLabel>
								<Select
									labelId="select-acesso-label"
									name="acessoTipo"
									value={formData.acessoTipo}
									label="Tipo de acesso"
									onChange={handleTypeChange}
								>
									{TYPE_ACCESS_OPTIONS.map((option) => (
										<MenuItem key={option.value} value={option.value}>
											{option.label}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						)}

						{/* --- TAG SELECTOR (Refatorado) --- */}

						<TagSelector
							selectedTags={formData.tags}
							onChange={handleTagsSelectionChange}
							type={formData.acessoTipo}
							title={getTagTitle(formData.acessoTipo)}
							subtitle={"Selecione a tag correspondente"}
						/>
					</Box>

					<Divider />

					{/* TIPO 0: VM */}
					{formData.acessoTipo === 0 && (
						<Box>
							<Box
								sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
							>
								<DevicesOtherOutlined
									sx={{ color: theme.palette.primary.main }}
								/>
								<Typography variant="mySubtitle2">VM / Servidor</Typography>
							</Box>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
								<Box
									sx={{
										display: "flex",
										gap: 2,
										flexDirection: { xs: "column", sm: "row" },
									}}
								>
									<TextField
										name="ip"
										label="IP"
										size="small"
										value={formData.ip}
										onChange={handleChange}
										error={!!errors.ip}
										helperText={errors.ip}
										fullWidth
										placeholder="0.0.0.0"
									/>
									<TextField
										name="sshPort"
										label="SSH Port"
										type="number"
										size="small"
										value={formData.sshPort}
										onChange={handleChange}
										error={!!errors.sshPort}
										helperText={errors.sshPort}
										fullWidth
										sx={{
											"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
												{
													display: "none",
													margin: 0,
												},
											"& input[type=number]": {
												MozAppearance: "textfield",
											},
										}}
									/>
								</Box>
								<Box
									sx={{
										display: "flex",
										gap: 2,
										flexDirection: { xs: "column", sm: "row" },
									}}
								>
									<TextField
										name="sshUser"
										size="small"
										label="SSH User"
										value={formData.sshUser}
										onChange={handleChange}
										fullWidth
									/>
									<TextField
										name="sshPass"
										label="SSH Pass"
										size="small"
										value={formData.sshPass}
										onChange={handleChange}
										fullWidth
									/>
									<TextField
										name="rootPass"
										label="Root Pass"
										size="small"
										value={formData.rootPass}
										onChange={handleChange}
										fullWidth
									/>
								</Box>
							</Box>
						</Box>
					)}

					{/* TIPO 1: DB */}
					{formData.acessoTipo === 1 && (
						<Box>
							<Box
								sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
							>
								<StorageOutlined sx={{ color: theme.palette.primary.main }} />
								<Typography variant="mySubtitle2">Banco de Dados</Typography>
							</Box>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
								<Box
									sx={{
										display: "flex",
										gap: 2,
										flexDirection: { xs: "column", sm: "row" },
									}}
								>
									<TextField
										name="dbHost"
										label="Host / IP"
										size="small"
										value={formData.dbHost}
										onChange={handleChange}
										fullWidth
										placeholder="0.0.0.0"
									/>
									<TextField
										name="dbPort"
										label="Porta"
										type="number"
										size="small"
										value={formData.dbPort}
										onChange={handleChange}
										fullWidth
										sx={{
											"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
												{
													display: "none",
													margin: 0,
												},
											"& input[type=number]": {
												MozAppearance: "textfield",
											},
										}}
									/>
								</Box>
								<Box
									sx={{
										display: "flex",
										gap: 2,
										flexDirection: { xs: "column", sm: "row" },
									}}
								>
									<TextField
										name="dbName"
										label="Nome Database"
										size="small"
										value={formData.dbName}
										onChange={handleChange}
										fullWidth
									/>
									<TextField
										name="dbUser"
										label="Usuário DB"
										size="small"
										value={formData.dbUser}
										onChange={handleChange}
										fullWidth
									/>
									<TextField
										name="dbPass"
										label="Senha DB"
										size="small"
										value={formData.dbPass}
										onChange={handleChange}
										fullWidth
									/>
								</Box>
							</Box>
						</Box>
					)}

					{/* TIPO 2: WEB */}
					{formData.acessoTipo === 2 && (
						<Box>
							<Box
								sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
							>
								<VpnKeyOutlined sx={{ color: theme.palette.primary.main }} />
								<Typography variant="mySubtitle2">
									Acessos Web / Links
								</Typography>
							</Box>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
								{formData.web_accesses.map((item, index) => (
									<Paper
										key={index}
										elevation={0}
										sx={{
											display: "flex",
											p: 0,
											bgcolor: alpha(theme.palette.background.default, 0.4),
											overflow: "hidden",
											borderRadius: "16px",
											mt: 1,
											border: "1px solid",
											borderColor: "divider",
										}}
									>
										<Box
											sx={{
												flexGrow: 1,
												p: 2,
												display: "flex",
												flexDirection: "column",
												gap: 2,
											}}
										>
											<TextField
												label={`Link / URL ${index + 1}`}
												size="small"
												value={item.url}
												onChange={(e) =>
													handleWebAccessChange(index, "url", e.target.value)
												}
												fullWidth
												InputProps={{
													endAdornment: item.url ? (
														<InputAdornment position="end">
															<IconButton
																onClick={() => handleOpenLink(item.url)}
																size="small"
															>
																<OpenInNew fontSize="small" />
															</IconButton>
														</InputAdornment>
													) : null,
												}}
											/>
											<Box
												sx={{
													display: "flex",
													gap: 2,
													flexDirection: { xs: "column", sm: "row" },
												}}
											>
												<TextField
													label="Login / E-mail"
													size="small"
													value={item.login}
													onChange={(e) =>
														handleWebAccessChange(
															index,
															"login",
															e.target.value,
														)
													}
													fullWidth
												/>
												<TextField
													label="Senha"
													size="small"
													value={item.pass}
													onChange={(e) =>
														handleWebAccessChange(index, "pass", e.target.value)
													}
													fullWidth
												/>
											</Box>
										</Box>
										{formData.web_accesses.length > 1 && (
											<Box
												onClick={() => handleRemoveWebAccess(index)}
												sx={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													width: 50,
													cursor: "pointer",
													borderLeft: "1px solid",
													borderColor: "divider",
													color: theme.palette.error.main,
													"&:hover": {
														backgroundColor: alpha(
															theme.palette.error.main,
															0.1,
														),
													},
												}}
											>
												<DeleteOutlined fontSize="small" />
											</Box>
										)}
									</Paper>
								))}
								<Button
									variant="dashed"
									sx={{ mt: 2, borderStyle: "dashed", borderWidth: 1 }}
									onClick={handleAddWebAccess}
									startIcon={<Add />}
									fullWidth
								>
									Adicionar Outro Link
								</Button>
							</Box>
						</Box>
					)}

					{/* TIPO 3: VPN */}
					{formData.acessoTipo === 3 && (
						<Box>
							<Box
								sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
							>
								<VpnLockOutlined sx={{ color: theme.palette.primary.main }} />
								<Typography variant="mySubtitle2">Configuração VPN</Typography>
							</Box>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
								<Box
									sx={{
										display: "flex",
										gap: 2,
										flexDirection: { xs: "column", sm: "row" },
									}}
								>
									<TextField
										name="vpnName"
										label="Nome da VPN"
										size="small"
										value={formData.vpnName}
										onChange={handleChange}
										fullWidth
									/>
									<TextField
										name="vpnGateway"
										label="Gateway"
										size="small"
										value={formData.vpnGateway}
										onChange={handleChange}
										fullWidth
									/>
								</Box>
								<Box
									sx={{
										display: "flex",
										gap: 2,
										flexDirection: { xs: "column", sm: "row" },
									}}
								>
									<TextField
										name="vpnUser"
										label="Usuário"
										size="small"
										value={formData.vpnUser}
										onChange={handleChange}
										fullWidth
									/>
									<TextField
										name="vpnPass"
										label="Senha"
										size="small"
										value={formData.vpnPass}
										onChange={handleChange}
										fullWidth
									/>
									<TextField
										name="vpnNTDomain"
										label="NT Domain"
										size="small"
										value={formData.vpnNTDomain}
										onChange={handleChange}
										fullWidth
									/>
								</Box>
								<Box
									sx={{
										display: "flex",
										gap: 2,
										flexDirection: { xs: "column", sm: "row" },
									}}
								>
									<FormControlLabel
										control={
											<Checkbox
												name="useL2TPEphemeral"
												checked={!!formData.useL2TPEphemeral}
												onChange={handleChange}
											/>
										}
										label="Use L2TP Ephemeral port"
									/>
									<FormControlLabel
										control={
											<Checkbox
												name="enableIPsec"
												checked={!!formData.enableIPsec}
												onChange={handleChange}
											/>
										}
										label="Enable IPsec tunnel"
									/>
								</Box>
								{formData.enableIPsec && (
									<TextField
										name="vpnPSK"
										label="Pre-shared key (PSK)"
										size="small"
										value={formData.vpnPSK}
										onChange={handleChange}
										fullWidth
										type="password"
									/>
								)}
							</Box>
						</Box>
					)}

					<Divider />

					{/* --- OBSERVAÇÕES (Comum a todos) --- */}
					<Box>
						<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
							<EditNoteOutlined sx={{ color: theme.palette.primary.main }} />
							<Typography variant="mySubtitle2">
								Anotações / Observações
							</Typography>
						</Box>
						<TextField
							name="observacoes"
							label="Observações Gerais"
							multiline
							minRows={5}
							value={formData.observacoes}
							onChange={handleChange}
							fullWidth
						/>
					</Box>
				</Box>
			</Paper>
		</Grid>
	);
}
